import { ofClass } from './ofClass';

/**
 * Returns true if (and only) the given value is a valid object
 */
export const isObject = ofClass('Object');
